import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/order-types')({
  beforeLoad: ({ context }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['tenants:manage', 'tenants:access-read-only'])
    ) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/order-types/pages/order-types-page')),
});
